import { PostHog, PostHogProvider } from 'posthog-js/react'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import NewAppRoot from '~/app/NewRoot'
import AppRoot from '~/app/Root'
import NewBizRoot from '~/biz/NewRoot'
import BizRoot from '~/biz/Root'
import XIDRAppRoot from '~/xidrApp/Root'
import XIDRBizRoot from '~/xidrBiz/Root'
import PageLoader from './components/PageLoader'
import { ConfigManager, SITE_TYPE } from './managers/ConfigManager'
import { useUnificationPhase2Flipper } from './store/flippers/hooks'
import {
  selectIsAssetUnificationPhase2Enabled,
  selectIsAssetUnificationPhase2Ready,
} from './store/flippers/selectors'

type Props = {
  posthog: PostHog
}

export default function RootRenderer({ posthog }: Props) {
  const isAssetUnificationPhase2Ready = useSelector(selectIsAssetUnificationPhase2Ready)
  const isAssetUnificationPhase2Enabled = useSelector(selectIsAssetUnificationPhase2Enabled)
  const isProd = ConfigManager.isProd()
  const rootComponent = useMemo(() => {
    if (!isAssetUnificationPhase2Ready) {
      return <PageLoader />
    }

    switch (ConfigManager.getSiteType()) {
      case SITE_TYPE.APP:
        return isProd ? (
          <PostHogProvider client={posthog}>
            {isAssetUnificationPhase2Enabled ? <NewAppRoot /> : <AppRoot />}
          </PostHogProvider>
        ) : (
          <>{isAssetUnificationPhase2Enabled ? <NewAppRoot /> : <AppRoot />}</>
        )

      case SITE_TYPE.XIDR_APP:
        return <XIDRAppRoot />

      case SITE_TYPE.BIZ:
        return isProd ? (
          <PostHogProvider client={posthog}>
            {isAssetUnificationPhase2Enabled ? <NewBizRoot /> : <BizRoot />}
          </PostHogProvider>
        ) : (
          <>{isAssetUnificationPhase2Enabled ? <NewBizRoot /> : <BizRoot />}</>
        )

      case SITE_TYPE.XIDR_BIZ:
        return <XIDRBizRoot />
    }

    return null
  }, [isAssetUnificationPhase2Ready, isAssetUnificationPhase2Enabled])

  useUnificationPhase2Flipper()

  return rootComponent
}
